import { lazy, type ComponentType } from 'react';

type Importer<T extends ComponentType<unknown>> = () => Promise<{ readonly default: T }>;

export function lazyWithPreloader<T extends ComponentType<unknown>>(importer: Importer<T>) {
	let promise: ReturnType<Importer<T>> | null = null;

	const preloadOnce = (): ReturnType<Importer<T>> => {
		promise ??= importer();
		return promise;
	};

	const Lazy = lazy(preloadOnce);

	return [Lazy, preloadOnce] as const;
}
